export const api_key = "CNCPxP9UN4rAl3jesMlk";
export const sdkWrapperURL = (url = "") =>
  new URL(url, "https://retail-api-prod-sdk-wrapper-app.carenow.healthcare/");
export const sdkURL = (url = "") =>
  new URL(url, "https://sdk.carenow.healthcare");
